import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const items = [{
  name: 'Complete manual "The Silent Fire" (55 pages)',
  value: '$7'
}, {
  name: 'Master shopping list with real costs',
  value: '$9'
}, {
  name: 'Golden Paste preparation guide',
  value: '$9'
}, {
  name: 'The 4 morning movements illustrated guide',
  value: '$9'
}, {
  name: 'Immediate access by digital download',
  value: 'Free'
}];
export function WhatYouGet() {
  return <section className="bg-forest-green py-12 md:py-16 px-4 sm:px-6 lg:px-8 text-white" data-id="element-249">
      <div className="max-w-3xl mx-auto" data-id="element-250">
        <FadeIn data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gold mb-12" data-id="element-252">
            Everything You Receive Today:
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-253">
          <div className="bg-white/5 rounded-2xl p-6 md:p-8 border border-white/10" data-id="element-254">
            <div className="space-y-6" data-id="element-255">
              {items.map((item, index) => <div key={index} className="flex items-center justify-between border-b border-white/10 pb-4 last:border-0 last:pb-0" data-id="element-256">
                  <div className="flex items-center gap-4 pr-4" data-id="element-257">
                    <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0" data-id="element-258" />
                    <span className="text-lg font-medium" data-id="element-259">{item.name}</span>
                  </div>
                  <span className="text-lg font-bold text-sage-light whitespace-nowrap" data-id="element-260">
                    {item.value}
                  </span>
                </div>)}
            </div>

            <div className="mt-8 pt-6 border-t-2 border-gold/30 flex items-center justify-between" data-id="element-261">
              <span className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-262">
                Total Value
              </span>
              <span className="text-3xl md:text-4xl font-bold text-gold line-through opacity-80" data-id="element-263">
                $34
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}